import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Home.vue'
import Index from   './views/index/index.vue'
import Service_education from './views/service_education/service_education.vue'
import Storage from './views/storage/storage.vue'
import Shop from './views/shop/shop.vue'
import Haotong from './views/Haotong/Haotong.vue'
import Cycle  from './views/Cycle/Cycle.vue'
import About from './views/About/About.vue'
import forwarder from './views/forwarder/forwarder.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // base:'/caspage/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children:[
        {
        // 首页
        path:'/',
        component:Index
      },
      {
        // 产品国际货代
        path:'/Service_education',
        component:Service_education
      },
      {
        // 国际货代
        path:'/forwarder',
        component:forwarder
      },
      {
        // 产品仓储配送
        path:'/Storage',
        component:Storage
      },
      {
        // 产品电商
        path:'/Shop',
        component:Shop
      },
      {
        // 周期购
        path:'/Cycle',
        component:Cycle
      },
      {
        // 产品浩通关
        path:'/Haotong',
        component:Haotong
      },
      
      
      {
        //服务
        path:'/About',
        component:About
      },
      ]
    },

  ]
})
